module.exports = __webpack_public_path__ + "static/media/3_badger.fed38fa8.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/3_badger.png
// module id = 116
// module chunks = 0